import MaintenancePage from "../MaintenancePage";
import Resource from "features/maintenance/resources/userGroupResource";

export default function UserGroups() {
    return <MaintenancePage resource={Resource} />;
}
